/**
 * Адаптер ответа сервера → выполнение UI-команд.
 *
 * Задачи:
 *  - Для каждой серверной команды найти подходящих провайдеров в реестре.
 *  - В порядке приоритета провайдеров вызвать `adapt(...)` и собрать токены.
 *  - Выполнить полученные токены через `UiCommandRunner`.
 *
 * Особенности:
 *  - Провайдеры вызываются **в порядке, возвращённом реестром** (ожидается сортировка по `priority` в `providersFor`).
 *  - Поддерживается короткое замыкание: если провайдер вернул `{ consumed: true }`,
 *    оставшиеся провайдеры для этой команды не вызываются.
 *  - Если ни один провайдер не сгенерировал токены — команда пропускается с предупреждением в консоли.
 */
class ServerResponseCmdAdapter {
    constructor(runner, registry) {
        this.runner = runner;
        this.registry = registry;
    }
    /**
     * Обработать массив серверных команд и выполнить соответствующие UI-команды.
     *
     * @param response Набор «сырых» команд от сервера
     * @param ctx Контекст исполнения для UI-раннера
     * @returns Результаты выполнения UI-команд
     */
    run(response, ctx) {
        const results = [];
        for (const cmd of response ?? []) {
            const providers = this.registry.providersFor(String(cmd.type));
            if (providers.length === 0) {
                console.error(`[ServerResponseCmdAdapter] no providers for type=${cmd.type}`);
                continue;
            }
            let consumed = false;
            let adapted = 0;
            // Вызываем провайдеры по очереди (ожидается, что реестр уже отсортировал по priority).
            for (const p of providers) {
                if (consumed)
                    break;
                try {
                    const res = p.adapt(cmd, ctx) ?? { tokens: [] };
                    if (res?.consumed === true) {
                        consumed = true;
                    }
                    if (res?.tokens?.length) {
                        adapted++;
                        p.finalizeTokens(cmd, ctx, res);
                        // TODO: добавить метод который принимал бы cmd, ctx и res и дорабатывал бы маску
                        const r = this.runner.runMany(res.tokens, ctx);
                        if (r)
                            results.push(...r);
                    }
                }
                catch (e) {
                    console.error(`[ServerCmdProvider:${p.id}] adapt failed for ${cmd.type}`, e);
                }
            }
            if (adapted === 0) {
                console.error(`[ServerResponseCmdAdapter] type=${cmd.type} produced no tokens`);
                continue;
            }
        }
        return results;
    }
}

export { ServerResponseCmdAdapter };
